<div class="flex flex-col w-full mb-4">
  <label *ngIf="label" [attr.for]="id" class="block mb-2 text-gray-900 body-small-regular" [id]="id">
    {{ label }}
  </label>
  <div *ngIf="loading" class="flex items-center justify-center w-full h-12 border border-gray-300 rounded">
    <app-loading-indicator [size]="25"></app-loading-indicator>
  </div>

  <ng-container *ngIf="!loading">
    <div class="relative">
      <button
        #toggleButton
        type="button"
        class="btn flex items-center relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-grey-700 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-brand-orange sm:text-sm sm:leading-6 h-12 brightness-100"
        [class.ring-brand-orange]="isMenuOpen"
        (click)="onSelectButtonClick()"
        role="combobox"
        aria-haspopup="listbox"
        [attr.id]="id + 'Dropdown'"
        [attr.aria-expanded]="isMenuOpen"
        [attr.aria-labelledby]="id"
      >
        <span class="block truncate" id="defaultSelection">{{ getSelectedLabel() }}</span>
      </button>

      <div
        #menu
        class="absolute z-10 w-full py-1 text-base bg-white rounded-md shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
        [class.hidden]="!isMenuOpen"
      >
        <div class="flex items-center justify-between px-3 pt-4 pb-2">
          <span class="block truncate" id="selectedValue">{{ getSelectedLabel() }}</span>
          <span class="text-gray-400 underline cursor-pointer" (click)="onClearAllClick()" id="clearAll">Clear All</span>
        </div>
        <div *ngIf="showFilter" class="relative px-4 py-2 bg-grey-200">
          <div class="absolute inset-y-0 flex items-center text-gray-400 pointer-events-none start-0 ps-7">
            <fa-icon [icon]="faSearch"></fa-icon>
          </div>
          <input
            [(ngModel)]="filterText"
            [id]="id + '-filterText'"
            placeholder="Search"
            class="block w-full py-2 pl-3 pr-10 text-gray-900 border-0 rounded-sm outline-none ring-0 ps-10"
          />
        </div>
        <ul
          class="w-full overflow-auto max-h-60 scrollbar"
          tabindex="-1"
          role="listbox"
          [attr.aria-labelledby]="id"
        >
          <li
            class="relative py-2 pl-3 text-gray-900 cursor-default select-none pr-9"
            *ngFor="let option of getOptions()"
            role="option"
            [id]="'listbox-option-' + option.value"
            (click)="onSelectOptionClick(option.value)"
            [class.bg-blue-50]="value === option.value"
          >
            <span class="block font-normal truncate">{{ option.label }}</span>
            <span
              class="absolute inset-y-0 right-0 flex items-center pr-4 text-brand-darkBlue"
              *ngIf="value === option.value"
            >
              <fa-icon [icon]="faCheck"></fa-icon>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</div>
